import { filter } from 'lodash';

import { useEffect, useState } from 'react';
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  TableHead,
  Box,
  TableSortLabel,
  CircularProgress,
} from '@mui/material';
// components

import Iconify from '../../Components/iconify';

// sections
import { UserListToolbar } from '../../sections/@dashboard/user';
import axiosInstance from '../../api/axiosInstance';

import DeleteModal from '../../Components/deleteModal/DeleteModal';
import NewBusiness from '../../Components/NewBusiness/NewBusiness';
import SnackbarComponent from '../../Components/Snackbar/Snackbar';
import { useNavigate } from 'react-router-dom';
import { Devices, Edit, QueryBuilder } from '@mui/icons-material';
import ExpireDateModal from '../../Components/ExpireDateModal/ExpireDateModal';
import moment from 'moment';




const TABLE_HEAD = [
  { id: 'nameB', label: 'Name', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'user', label: 'User', alignRight: false },
  { id: 'vhost', label: 'VHost', alignRight: false },
  { id: 'serial', label: 'Serial', alignRight: false },
  { id: 'expire', label: 'Expire Date', alignRight: false },
  { id: 'devices', label: 'Devices', alignRight: false },

];

const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  clip: 'rect(0 0 0 0)',
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_b) => _b.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function Business() {


  const [business, setBusiness] = useState([])
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false);
  const getBusiness = async () => {
    setLoading(true)
    try {
      const res = await axiosInstance.get("/business")
      if (res.data) {
        setBusiness(res.data)
      } else {
        setBusiness([])
      }

    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }
  const getUsers = async () => {
    setLoading(true)
    try {
      const res = await axiosInstance.get("/user/no-business")
      setUsers(res.data)
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getBusiness()
    getUsers()
  }, [])


  const [open, setOpen] = useState(null);
  const [page, setPage] = useState(0);
  const [order] = useState('asc');
  const [orderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);



  const handleCloseMenu = () => {
    setOpen(null);
  };



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - 0) : 0;

  const filteredData = applySortFilter(business, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredData.length && !!filterName;

  const [newBusiness, setNewBusiness] = useState(false);
  const [toEditRow, setToEditRow] = useState(null)
  const [tempEditData, setTempEditData] = useState(null)



  const [deleteModal, setDeleteModal] = useState(false)
  const [expireModal, setExpireModal] = useState(false)

  const [openSanckbar, setOpenSnackBar] = useState(false);
  const [snackbarMsgType, setSnackbarMsgType] = useState({
    message: "",
    type: ""
  })

  const handleDelete = async () => {
    if (tempEditData == null) { return }
    try {
      await axiosInstance.delete(`/business/${tempEditData.businessid}`)
      setBusiness(business.filter(b => b.businessid != tempEditData.businessid))
      setTempEditData(null)
      setDeleteModal(false)
      handleCloseMenu()
      setOpenSnackBar(true)
      setSnackbarMsgType({
        message: "User Deleted Successfully",
        type: "success"
      })
    } catch (err) {
      console.log(err)
      setOpenSnackBar(true)
      setSnackbarMsgType({
        message: "Cant delete this user",
        type: "error"
      })
    }

    if (tempEditData == null) { return }
    try {
      await axiosInstance.delete(`/business/${tempEditData.businessid}`)
      setBusiness(business.filter(b => b.businessid != tempEditData.businessid))
      setTempEditData(null)
      setDeleteModal(false)
      handleCloseMenu()
      setOpenSnackBar(true)
      setSnackbarMsgType({
        message: "User Deleted Successfully",
        type: "success"
      })
    } catch (err) {
      console.log(err)
      setOpenSnackBar(true)
      setSnackbarMsgType({
        message: "Cant delete this user",
        type: "error"
      })
    }

  }

  const statuses = ["Active", "Inactive", "Closed", "Under Renovation", "Out of Stock"]
  const navigate = useNavigate();

  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} mt={3}>
          <Typography variant="h4" gutterBottom>
            Business
          </Typography>
          <Button variant="contained" onClick={() => setNewBusiness(true)} startIcon={<Iconify icon="eva:plus-fill" />}>
            New Business
          </Button>
        </Stack>

        <Card>
          <UserListToolbar numSelected={0} filterName={filterName} onFilterName={handleFilterByName} />


          <TableContainer sx={{ width: "100%", overflow: "auto", maxHeight: "500px" }}>
            <Table sx={{ overflow: "auto" }}>
              <TableHead >
                <TableRow>

                  {TABLE_HEAD.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align={headCell.alignRight ? 'right' : 'left'}
                      sortDirection={orderBy === headCell.id ? order : false}
                    >
                      <TableSortLabel
                        hideSortIcon
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                      >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                          <Box sx={{ ...visuallyHidden }}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ?
                  <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                    <CircularProgress />
                  </Box>

                  : filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { name, status, vhost, businessid, user ,expiredate,serial} = row;

                    return (
                      <TableRow hover key={businessid} tabIndex={-1} role="checkbox" >


                        <TableCell align="left">{name}</TableCell>
                        <TableCell align="left">{statuses[status]}</TableCell>
                        <TableCell align="left">{user?.username}</TableCell>
                        <TableCell align="left">{vhost}</TableCell>
                        <TableCell align="left">{serial}</TableCell>
                        <TableCell sx={{display:"flex",alignItems:"center",gap:1}}>
                       
                            <Typography sx={{color:expiredate ? "black" : "red"}}>{expiredate ?  moment(expiredate).format("DD/MM/YYYY") : "none"}</Typography>
                            <IconButton color="info" onClick={()=>{
                              setToEditRow(row)
                              setExpireModal(true)
                            }}><QueryBuilder/></IconButton>
                         
                        </TableCell>
                        <TableCell align="left">
                          {/* <IconButton size="large" color="inherit" onClick={(e) => { handleOpenMenu(e); handleEditOpen(row) }}>
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton> */}
                          <IconButton size="large" color="info" onClick={(e) => {
                            sessionStorage.setItem("businessId", businessid)
                            sessionStorage.setItem("user", JSON.stringify(user))
                            navigate('/devices')
                          }}>
                            <Devices  />
                          </IconButton>
                        </TableCell>
                       
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>

              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >
                        <Typography variant="h6" paragraph>
                          Not found
                        </Typography>

                        <Typography variant="body2">
                          No results found for &nbsp;
                          <strong>&quot;{filterName}&quot;</strong>.
                          <br /> Try checking for typos or using complete words.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>


          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => {
          setNewBusiness(true)
          setToEditRow(tempEditData)
          handleCloseMenu()
        }}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }} onClick={() => setDeleteModal(true)}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
      {
        newBusiness ? <NewBusiness setSnackbarMsgType={setSnackbarMsgType} setOpenSnackBar={setOpenSnackBar} setOpen={setNewBusiness} getData={getBusiness} toEditRow={toEditRow} setToEditRow={setToEditRow} users={users} /> : ""
      }
      {
        deleteModal ? <DeleteModal setOpen={setDeleteModal} handleDelete={handleDelete} item="business" /> : ""
      }
      {
        expireModal ? <ExpireDateModal setOpen={setExpireModal} cid={toEditRow?.name} serial={toEditRow?.serial} current={toEditRow?.expiredate} setToEditRow={setToEditRow} bussinessId={toEditRow.businessid} getData={getBusiness} setSnackbarMsgType={setSnackbarMsgType} setOpenSnackBar={setOpenSnackBar}/> :""
      }
      <SnackbarComponent open={openSanckbar} setOpen={setOpenSnackBar} message={snackbarMsgType.message} type={snackbarMsgType.type} />
    </>
  );
}
